import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { PayabliClientConfig, PaymentSettings } from '@/types/settings';

export function usePaymentSettings(options: { enabled?: boolean } = {}) {
  return useApiQuery<PaymentSettings>({
    queryKey: settingsKeys.payments(),
    queryFn: () => apiGet<PaymentSettings>(operationsClient, settingsEndpoints.paymentSettings()),
    enabled: options.enabled ?? true,
    showErrorToast: false,
  });
}

/**
 * Browser-safe Payabli config (entryPoint + public token) for the embedded
 * save-a-card component. Only fetch when Payabli is the primary processor —
 * pass `enabled` accordingly.
 */
export function usePayabliClientConfig(options: { enabled?: boolean } = {}) {
  return useApiQuery<PayabliClientConfig>({
    queryKey: settingsKeys.payabliClientConfig(),
    queryFn: () =>
      apiGet<PayabliClientConfig>(operationsClient, settingsEndpoints.payabliClientConfig()),
    enabled: options.enabled ?? true,
    showErrorToast: false,
  });
}
